<template>
  <div class="container">
    <Search></Search>
    <TabBar></TabBar>  
    <BannerList :bannerList="bannerList"></BannerList>
	  <GoodKind :allInfomation="allInfomation"></GoodKind>
    <!-- 秒杀 -->
    <!-- <Spike/> -->
    <!-- 拼团和砍价 -->
    <!-- <div class="activities-box">
      <div class="activities">
        <Fight />
      </div>
      <div class="activities">
        <Bargain />
      </div>
    </div> -->
    <!-- 频道 -->
    <IndexChannel :topic="topic"></IndexChannel>
    <!-- 商品显示区域 -->
    <ProductSpecial :activity="activity" :advList="advList"></ProductSpecial>
    <DrugBlog :blogList="blogList"></DrugBlog>

  </div>
</template>

<script>
import Search from "@/components/pc/Search";
import TabBar from "@/components/pc/nav/TabBar";
import BannerList from "@/components/pc/nav/BannerList";
import GoodKind from "@/components/pc/activities/GoodKind";
import ProductSpecial from "@/components/pc/index/ProductSpecial";
import IndexChannel from "@/components/pc/index/IndexChannel";
import DrugBlog from "@/components/pc/index/DrugBlog";
// import Spike from '@/components/pc/activities/Spike'
// import Fight from "@/components/pc/activities/Fight";
// import Bargain from "@/components/pc/activities/Bargain";
import { getIndex } from "@api/public";
export default {
  name: "Index",
  data() {
    return {
      userInfo: {},
      setIntervalObj: null,
      bannerList: [],
      bastList: [],
      allInfomation: {}, // 首页所有信息
      topic: [], //导航栏频道信息
      activity: [], // 商品楼层信息
      advList: [], // 楼层下面的广告位
      blogList: [], // 博客信息

      title: "",
      keywords: "",
      description: ""
    };
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { name: "keywords", content: this.keywords },
        { name: "description", content: this.description }
      ]
    };
  },
  created() {
    getIndex().then(res => {
      this.bannerList = res.data.banner;
      this.bastList = res.data.info.bastList.product;

      this.allInfomation = res.data;
      this.topic = res.data.topic;
      this.activity = res.data.activity;
      this.advList = res.data.adv;
      this.blogList = res.data.blog;

      this.title = res.data.site_name;
      this.keywords = res.data.seo_keywords;
      this.description = res.data.seo_description;
    });
  },
  components: {
    Search,
    // Spike,
    // Fight,
    // Bargain,
    TabBar,
    BannerList,
    GoodKind,
    ProductSpecial,
    IndexChannel,
    DrugBlog,
  }
};
</script>

<style lang="stylus" scoped>
.container
  background-color #f8f8f8
   //padding-bottom 10px
  .activities-box
    width 1020px
    margin 0px auto
    display flex
    justify-content space-between
   .activities
      width 49%
      height 300px
      padding 10px 20px
      background #fff
      margin-top 20px
  .limit-banner
    width 1200px
    height 120px
    margin 0 auto
</style>
